import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

import { Item } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';

@Component({
  selector: 'app-smart-sms-number-classes-fields',
  templateUrl: './smart-sms-number-classes-fields.component.html',
  imports: [BaseFormModule],
})
export class SmartSmsNumberClassesFieldsFieldsComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  model: Item = {};
  selectedProvince;

  @Input() index: number;
  @Input('classModel') classModel: Item;
  @Input('isEdit') isEdit: boolean;

  @Output('city') output_city = new EventEmitter<string>();
  @Output('cityId') output_cityId = new EventEmitter<number>();
  @Output('province') output_province = new EventEmitter<string>();
  @Output('class') output_class = new EventEmitter<number>();
  @Output('form') output_form = new EventEmitter<FormGroup>();

  @Output('removeClass') output_removeClass = new EventEmitter<number>();

  //#endregion

  ngOnInit() {
    try {
      super.ngOnInit();
      this.detectChangeForm();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  initModel() {
    try {
      // when form is edit mode
      if (this.isEdit) {
        this.model = Object.assign({}, this.classModel);
      } // when form is create mode
      else this.formPageConfig.editData = {};
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  initForm() {
    this.form = new FormGroup({
      city: new FormControl('', Validators.required),
      province: new FormControl('', Validators.required),
      class: new FormControl('', Validators.required),
    });
  }

  //#region emit
  onChangeCity() {
    this.output_city.emit(this.model.city);
    this.output_cityId.emit(this.model.cityId);
  }

  onChangeProvince() {
    this.output_province.emit(this.model.province);
  }
  onChangeClass() {
    this.output_class.emit(this.model.class);
  }

  onRemoveClass(i) {
    this.output_removeClass.emit(i);
  }

  emitForm() {
    this.output_form.emit(this.form);
  }

  //#endregion

  onChangeZones(province) {
    this.model.cityId = -1;
    this.selectedProvince = province.id;
    this.model.province = province.name;
    this.onChangeProvince();
  }

  onCityChange(city) {
    this.model.cityId = city.id;
    this.model.city = city.name;
    this.onChangeCity();
  }

  detectChangeForm() {
    try {
      this.form.valueChanges
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((event) => {
          this.emitForm();
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }
}
